export const createCSVContent = (header: string, rows: string[]) => {
    const csvContent = 'data:text/csv;charset=utf-8,';
    return encodeURI(csvContent + header + rows.join(''));
};

export const createJSONContent = (jsonData: object[]) => {
    const jsonContent = 'data:text/json;charset=utf-8,';
    return encodeURI(jsonContent + JSON.stringify(jsonData));
};

export const downloadCreatedFile = (encodedUri: string, filename: string) => {
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
